class TimedPageActions {
    // Global search
    static readonly SEARCH_FRONTEND = 'search_frontend';

    // Auth / context switching
    static readonly SWITCH_ACCOUNT = 'switch_account';

    static readonly USER_LOGIN = 'user_login';

    static readonly IMPERSONATE_USER = 'impersonate_user';

    // Communication modals
    static readonly NIOTEXT_LOAD_MODAL = 'niotext_load_modal';

    static readonly SMS_MODULE_LOAD_DRAWER = 'sms_module_load_drawer';

    static readonly EMAIL_LEAD_MODAL_LOAD = 'email_lead_modal_load';

    static readonly COMMUNICATION_LIST_EMAIL_MODAL_LOAD = 'communication_list_email_modal_load';

    static readonly COMMUNICATION_LIST_SMS_HISTORY_LOAD = 'communication_list_sms_history_load';

    static readonly COMMUNICATION_LIST_SMS_MODULE_HISTORY_LOAD =
        'communication_list_sms_module_history_load';

    // Generic filter actions
    static readonly FILTER_APPLY = 'filter_apply';

    static readonly CALENDAR_FILTER_APPLY = 'calendar_filter_apply';

    static readonly CALENDAR_VIEW_APPLY = 'calendar_view_apply';

    // Dashboard lead table filters
    static readonly ALL_LEAD_TABLE_FILTER = 'all_lead_table_filter';

    static readonly LEAD_XPRESS_TABLE_FILTER = 'lead_xpress_table_filter';

    static readonly WEB_ORDER_TABLE_FILTER = 'web_order_table_filter';

    static readonly WEB_BOOST_TABLE_FILTER = 'web_boost_table_filter';

    static readonly WALK_IN_TABLE_FILTER = 'walk_in_table_filter';

    static readonly PHONE_UP_TABLE_FILTER = 'phone_up_table_filter';

    static readonly LOYALTY_TABLE_FILTER = 'loyalty_table_filter';

    static readonly RENEWAL_TABLE_FILTER = 'renewal_table_filter';

    static readonly COMMERCIAL_TABLE_FILTER = 'commercial_table_filter';

    static readonly SERVICE_TABLE_FILTER = 'service_table_filter';

    static readonly EVENT_TABLE_FILTER = 'event_table_filter';

    static readonly SALE_TABLE_FILTER = 'sale_table_filter';
}

export default TimedPageActions;
